import React from 'react';
import { URL } from 'appConstants';
import MediaShell from '../MediaShell';
import MediaV4List from '../MediaV4List';

const MediaArticles = () => (
  <MediaShell
    title="Статьи"
    crumbCurrent="Статьи"
  >
    <MediaV4List
      requestUrl={URL.NEWS.ARTICLES.GET}
      badge="СТАТЬИ"
      action="detail"
    />
  </MediaShell>
);

export default MediaArticles;
